/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useReducer, useCallback, useMemo } from 'react';
// utils
import axios, { endpoints } from 'src/utils/axios';
//
import { AuthContext } from './auth-context';
import { isValidToken, setSession } from './utils';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { paths } from 'src/routes/paths';

import { useNavigate } from 'react-router-dom';

const initialState = {
  user: null,
  loading: true,
};

const reducer = (state, action) => {
  if (action.type === 'INITIAL') {
    return {
      loading: false,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGIN') {
    return {
      ...state,
      user: action.payload.user,
    };
  }
  if (action.type === 'REGISTER') {
    return {
      ...state,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGOUT') {
    return {
      ...state,
      user: null,
    };
  }
  return state;
};

// ----------------------------------------------------------------------

const STORAGE_KEY = 'accessToken';

export function AuthProvider({ children }) {
  const navigate = useNavigate();

  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => { // useCallback memoizes the function
    try {
      // Get the user from localStorage
      let user = JSON.parse(localStorage.getItem('user')); // Retrieve user from localStorage
      let token = localStorage.getItem('accessToken'); // Retrieve user from localStorage
      setSession(token)
      // console.log("initialize user: ", user); // Log the user to console
      dispatch({
        type: 'INITIAL',
        payload: {
          user,
        },
      });
    } catch (error) {
      console.error('Error initializing:', error);
      dispatch({
        type: 'INITIAL',
        payload: {
          user: null,
        },
      });
    }
  }, [dispatch]); // Dependency array for useCallback

  useEffect(() => {
    initialize();
  }, [initialize]);

  // API login
  const login = useCallback(async (email, password, router) => {
    const data = {
      email,
      password,
    };


    try {
      const response = await axios.post(endpoints.auth.login, data);
      const { token, user } = response.data.payload;
      console.log(user, token)
      localStorage.setItem(STORAGE_KEY, token);
      localStorage.setItem('user', JSON.stringify(user)); // Save the user to localStorage
      // Set the session with the token
      setSession(token);

      dispatch({
        type: 'LOGIN',
        payload: {
          user,
        },
      });
      if (user.role[0].name === 'admin') {
        navigate(PATH_AFTER_LOGIN, { replace: true });
      } else if (user.role[0].name === 'user') {
        navigate(paths.userDashboard.root, { replace: true });
      }
      return response.data
    } catch (error) {
      return error

      console.error('Error during login:', error);
    }
  }, []);



  // REGISTER
  const register = useCallback(async (email, password, firstName, lastName) => {
    const data = {
      email,
      password,
      firstName,
      lastName,
    };

    const response = await axios.post(endpoints.auth.register, data);

    const { token, user } = response.data;

    localStorage.setItem(STORAGE_KEY, token);

    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  }, []);

  // LOGOUT
  const logout = useCallback(async () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('user');
    console.log(`03 logout  Item with key '${STORAGE_KEY}' removed from localStorage.`);

    dispatch({
      type: 'LOGOUT',
    });
  }, []);

  // ----------------------------------------------------------------------

  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      method: 'jwt',
      loading: status === 'loading',
      authenticated: status === 'authenticated',
      unauthenticated: status === 'unauthenticated',
      //
      login,
      register,
      logout,
    }),
    [login, logout, register, state.user, status]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node,
};
